import { Colors, Icon } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface StartAssessmentStepProps {
    disabled: boolean;
    onStart: () => void;
    dataTestId?: string;
}

export const StartAssessmentStep = ({
    disabled,
    onStart,
    dataTestId = 'section-start-assessment',
}: StartAssessmentStepProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={'flex flex-col gap-6'}
            data-testid={dataTestId}
        >
            <div
                className={
                    'flex flex-col gap-6 rounded-2xl border border-white bg-white/90 p-6 md:!p-[53px]'
                }
            >
                <p className={'max-w-[667px] text-sm font-medium text-gray-900'}>
                    {t('managerAssessmentSetup.startAssessmentDesc')}
                </p>

                <button
                    type={'button'}
                    disabled={disabled}
                    onClick={onStart}
                    className={
                        'flex h-[36px] w-fit items-center gap-2 rounded-lg border px-4 text-sm font-medium text-white shadow-sm transition-all hover:opacity-90 hover:shadow-md disabled:opacity-50'
                    }
                    style={{
                        backgroundImage: 'var(--gradient-primary-button)',
                        borderColor: 'var(--color-primary-800)',
                    }}
                    data-testid={'start-assessment-button'}
                >
                    <Icon
                        name={'time-timer-start'}
                        size={20}
                        color={Colors.WHITE}
                    />

                    {t('managerAssessmentSetup.startAssessment')}
                </button>
            </div>
        </div>
    );
};
